import { FinalDisciplinaryActionEntity } from 'src/store/final-disciplinary-action/final-disciplinary-action.model';
import { PrdProcessingState } from './pilot-view-model';

export function createPrdActionTypes() {
  const codes = {
    SWP: 'Suspension',
    TER: 'Termination',
    WRT: 'Written Warning',
  };
  const actionTypes = Object.keys(codes).map((code) => ({
    code: code as keyof typeof codes,
    description: codes[code as keyof typeof codes],
  }));
  return {
    actionTypes,
    codeToDescription: (code: keyof typeof codes) => codes[code],
  };
}

// export enum PrdActionType {
//   SWP = 'SWP',
//   TER = 'TER',
//   WRT = 'WRT',
// }
export class FinalDisciplinaryActionViewModel implements FinalDisciplinaryActionEntity {
  public id: string;
  public pilotId: string;
  public actionDate: Date;
  public actionType: string;
  public processingState: PrdProcessingState;
  public lastProcessedDate: Date;
  public processingError: string;
  public removalFromOperations: boolean;
  public relevantDocuments: boolean;
  public suppressed: boolean;
  public prdSourceSystemId: string;

  constructor(finalDisciplinaryAction: FinalDisciplinaryActionEntity) {
    Object.assign(this, finalDisciplinaryAction);
  }
}
